/** What the roster's approve button does right now. */
export interface ApproveControl {
  label: string;
  count: number;
  pending: boolean;
  onClick: () => void;
  /** True when acting on the checkbox selection rather than the whole queue. */
  isSelection: boolean;
}

/**
 * A selection takes over the approve button; otherwise it falls back to
 * "approve all eligible". Null hides the button.
 */
export function pickApproveControl(
  selection: ApproveControl | null,
  approveAll: ApproveControl | null,
): ApproveControl | null {
  return selection ?? approveAll;
}

export interface SelectionApproveSource {
  selectedCount: number;
  approveSelectedLabel: string | null;
  approvePending: boolean;
  openApprove: () => void;
}

/** Approve control for the current checkbox selection, or null when there is none. */
export function selectionApproveControl(bulk: SelectionApproveSource): ApproveControl | null {
  if (bulk.selectedCount === 0 || !bulk.approveSelectedLabel) return null;
  return {
    label: bulk.approveSelectedLabel,
    count: bulk.selectedCount,
    pending: bulk.approvePending,
    onClick: bulk.openApprove,
    isSelection: true,
  };
}

const APPROVE_ALL_LABEL = 'Approve all';

/** "Approve all eligible" control, or null when there is nothing to approve. */
export function approveAllControl(visible: boolean, count: number, pending: boolean, onClick: () => void): ApproveControl | null {
  if (!visible || count === 0) return null;
  return { label: APPROVE_ALL_LABEL, count, pending, onClick, isSelection: false };
}
